let isProcessingRemoval = false;
let removalQueue = [];

/* -------------------------------
   🔹 Inject Loader Styles (once)
--------------------------------*/
(function injectStyles() {
    if (document.getElementById("cart-loader-styles")) return;

    const style = document.createElement("style");
    style.id = "cart-loader-styles";
    style.innerHTML = `
        .cart-loader-overlay {
            position: absolute;
            inset: 0;
            background: rgba(255,255,255,0.6);
            z-index: 9999;
        }

        .cart-loader-spinner {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40px;
            height: 40px;
            border: 3px solid #ccc;
            border-top: 3px solid #000;
            border-radius: 50%;
            transform: translate(-50%, -50%);
            animation: cartSpin 0.8s linear infinite;
        }

        @keyframes cartSpin {
            to {
                transform: translate(-50%, -50%) rotate(360deg);
            }
        }

        .cart-global-loader {
            position: fixed;
            inset: 0;
            z-index: 99999;
        }

        .cart-drawer-loader {
            position: absolute;
            inset: 0;
            z-index: 99999;
        }
    `;
    document.head.appendChild(style);
})();

/* -------------------------------
   🔹 Create Loader Elements
--------------------------------*/
function createLoader(type) {
    const container = document.createElement("div");
    container.className =
        type === "drawer" ? "cart-drawer-loader" : "cart-global-loader";

    const overlay = document.createElement("div");
    overlay.className = "cart-loader-overlay";
    overlay.innerHTML = "&nbsp;"

    const spinner = document.createElement("div");
    spinner.className = "cart-loader-spinner";
    spinner.innerHTML = "&nbsp;"

    container.appendChild(overlay);
    container.appendChild(spinner);

    return container;
}

/* -------------------------------
   🔹 Detect Drawer
--------------------------------*/
function getCartDrawer() {
    return document.querySelector("cart-drawer[open], .cart-drawer.is-open");
}

/* -------------------------------
   🔹 Show Loader
--------------------------------*/
function showLoader() {
    const drawer = getCartDrawer();

    if (drawer) {
        if (!drawer.querySelector(".cart-drawer-loader")) {
            const loader = createLoader("drawer");

            // Ensure positioning context
            if (getComputedStyle(drawer).position === "static") {
                drawer.style.position = "relative";
            }

            drawer.appendChild(loader);
        }
    } else {
        if (!document.querySelector(".cart-global-loader")) {
            const loader = createLoader("global");
            document.body.appendChild(loader);
        }
    }

    document.body.style.pointerEvents = "none";
}

/* -------------------------------
   🔹 Hide Loader
--------------------------------*/
function hideLoader() {
    document.querySelectorAll(".cart-global-loader, .cart-drawer-loader")
        .forEach(el => el.remove());

    document.body.style.pointerEvents = "";
}

/* -------------------------------
   🔹 Main Logic
--------------------------------*/
document.addEventListener("cart:updated", (e) => {
    const cart = e.detail?.cart;
    if (!cart) return;

    const removedItems = cart.items_removed || [];
    const GIFT_BOX_VARIANT_ID = 51331759309111;

    if (isProcessingRemoval) return;

    const isGiftBoxRemoved = removedItems.some(
        item => item.variant_id === GIFT_BOX_VARIANT_ID
    );

    if (!isGiftBoxRemoved) return;
    if (!cart.items || cart.items.length === 0) return;

    const boxIdsWithGiftBox = new Set();

    cart.items.forEach(item => {
        const boxId = item.properties?.["Box Id"];
        if (item.variant_id === GIFT_BOX_VARIANT_ID && boxId) {
            boxIdsWithGiftBox.add(boxId);
        }
    });

    const itemsToRemove = cart.items.filter(item => {
        const boxId = item.properties?.["Box Id"];
        return boxId && !boxIdsWithGiftBox.has(boxId);
    });

    if (itemsToRemove.length === 0) return;

    removalQueue = [...itemsToRemove];
    isProcessingRemoval = true;

    showLoader(); // 🔥 Start loader

    processNextItem();
});

/* -------------------------------
   🔹 Queue Processor
--------------------------------*/
async function processNextItem() {
    if (removalQueue.length === 0) {
        isProcessingRemoval = false;
        window.location.reload();
        hideLoader(); // 🔥 Stop loader
        return;
    }

    const item = removalQueue.shift();
    if (!item) {
        isProcessingRemoval = false;
        hideLoader();
        return;
    }

    try {
        await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: item.key,
                quantity: 0
            })
        });

        const url = `/cart/change?id=${item.key}&quantity=0`;

        const cartEle = document.querySelector(`[href="${url}"]`);
        if (cartEle.closest(".cart-item")) {
            cartEle.closest(".cart-item").remove();
        }

        setTimeout(processNextItem, 300);

    } catch (err) {
        console.error("Removal failed:", err);
        setTimeout(processNextItem, 300);
    }
}